import { useState, useEffect } from 'react'
import { getContent } from '@/lib/api'
import type { ContentData } from '@/types'

interface UsePreviewSectionReturn {
  content: ContentData
  isLoading: boolean
  error: string | null
}

export function usePreviewSection(sectionKey: string): UsePreviewSectionReturn {
  const [content, setContent] = useState<ContentData>({})
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const load = async () => {
      setIsLoading(true)
      setError(null)

      try {
        // Try to fetch draft content first
        const draftResponse = await getContent(sectionKey, { draft: true }).catch(() => null)

        if (draftResponse?.content) {
          setContent(draftResponse.content)
        } else {
          // Fall back to live content if no draft
          const liveResponse = await getContent(sectionKey)
          setContent(liveResponse.content)
        }
      } catch (err) {
        if (err instanceof Error && err.message.includes('404')) {
          setContent({})
        } else {
          setError(err instanceof Error ? err.message : 'Erreur de chargement')
        }
      } finally {
        setIsLoading(false)
      }
    }

    load()
  }, [sectionKey])

  return {
    content,
    isLoading,
    error,
  }
}
